export enum NextcloudActionType {
    SetCircles = 'nextcloud.SET_CIRCLES',
    SetShares = 'nextcloud.SET_SHARES',
}
